export const convertKeys = (obj, keyTypeMap, overwrites) => {
  if (typeof obj === 'object' && obj !== null){
    for (const key in obj){
      if (key in keyTypeMap){
        const targetType = keyTypeMap[key];
        if (key in overwrites) {
          obj[key] = overwrites[key];
        }
        else if (targetType === 'boolean'){
          if (obj[key].toLowerCase() === 'true'){
            obj[key] = true;
          } else if (obj[key].toLowerCase() === 'false'){
            obj[key] = false;
          }
        } else if (targetType === 'integer'){
          if (!isNaN(obj[key])){
            obj[key] = parseInt(obj[key])
          }
        }
      } else if (typeof obj[key] === 'object'){
        convertKeys(obj[key], keyTypeMap, overwrites)
      }
    }
  }
  return obj
}

export const stepFullyConfigured = (stepSettings) => {
  return !(
    stepSettings == undefined ||
    Object.keys(stepSettings).length == 0 ||
    (stepSettings.set_value == 'default_value' && stepSettings.default_value == undefined) ||
    (stepSettings.set_value == 'excel_column' && stepSettings.excel_column == undefined)
  )
}

export const COLUMN_ERROR_LIMIT = 1000;

export const validationDisplayCount = (validationErrors) => {
  if (validationErrors?.length >= COLUMN_ERROR_LIMIT) {
    return '1000+';
  }
  return validationErrors?.length;
}

export function flattenMostFrequent(grid) {
  if (!grid.length) return [];

  const numCols = grid[0].length;
  const result = [];

  for (let col = 0; col < numCols; col++) {
    const countsD = new Map();
    const countsN = new Map();

    for (let row = 0; row < grid.length; row++) {
      const { d, n } = grid[row][col];

      if (d !== undefined) {
        countsD.set(d, (countsD.get(d) || 0) + 1);
      }
      if (n !== undefined && n !== 'UNKNOWN_FORMAT') {
        countsN.set(n, (countsN.get(n) || 0) + 1);
      }
    }

    const mostD = [...countsD.entries()].reduce(
      (a, b) => (b[1] > a[1] ? b : a),
      [undefined, 0]
    )[0];

    const mostN = [...countsN.entries()].reduce(
      (a, b) => (b[1] > a[1] ? b : a),
      [undefined, 0]
    )[0];

    result.push({ d: mostD, n: mostN });
  }

  return result;
}
